import axios from "axios";

const TrendingCoins = (currency) =>
  `https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency}&order=gecko_desc&per_page=10&page=1&sparkline=false&price_change_percentage=24h`;

export async function TrendingCoinsData(currency, setFunction) {
  try {
    const response = await axios.get(TrendingCoins(currency));
    // setCryptoList(response.data);
    setFunction(response.data);
  } catch (error) {
    console.error(error);
  }
}
